import { CenterGroup } from '../../../lib/types/models/center-group/center-group'
import { AssignTeflToCenterGroupInput } from '../../../lib/types/models/center-group/center-group-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function assignTeflToCenterGroup(
  centerId: number,
  groupId: number,
  input: AssignTeflToCenterGroupInput
) {
  return restApiClient
    .url(constructApiUrl(API.centers.assignTeflToCenterGroup.url, { id: centerId, groupId }))
    .post<CenterGroup, AssignTeflToCenterGroupInput>(input)
}
